import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-final-form';
import { NewRadioButton } from '../../NewRadioButton';
import { regionsQuery } from '../../../queries/regions';
import Loader from '../../Loader';
import { NewSearchEmpty } from '../../NewSearch/NewSearchCities/NewSearchEmpty';
import { showPopupHeader, setError } from '../../../actions';
import { entitiesFilter, setCoordinates } from '../../../utils/helpers/common';
import { FORM_VALUES } from '../../../utils/helpers/constants';

const SelectLocation = ({
  isFocused,
  searchString,
  cancelHandler,
  closePopupHandler,
  setInitCoordinates
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { change, getState } = useForm();
  const currentLocationId = getState().values[FORM_VALUES.locationId];
  const cityId = getState().values[FORM_VALUES.cityId] || '';
  const locationsQueryVariables = { cityId };
  const { data, loading, error } = useQuery(
    regionsQuery(locationsQueryVariables),
    {
      variables: locationsQueryVariables
    }
  );

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  const onChangeRadioHandler = e => {
    const locationId = e.target.value;
    change(FORM_VALUES.locationId, locationId);
    const locationData = data.regions.find(
      location => location.id === locationId
    );
    change(FORM_VALUES.locationName, locationData?.name.trim());
    change(FORM_VALUES.villageId, undefined);
    change(FORM_VALUES.villageName, undefined);
    setCoordinates(locationData, setInitCoordinates);
    dispatch(showPopupHeader());
    closePopupHandler();
    cancelHandler();
  };

  const locationsList =
    (!isFocused || searchString) &&
    entitiesFilter(data?.regions || [], searchString).map(location => (
      <NewRadioButton
        data={location}
        key={location.id}
        cypress="location"
        name="select-location"
        currentValue={currentLocationId}
        onChangeHandler={onChangeRadioHandler}
      />
    ));

  const emptySearch = !locationsList.length && searchString && (
    <NewSearchEmpty
      onClickHandler={cancelHandler}
      linkText={t('search.locations_search.back')}
    />
  );

  if (error) {
    return null;
  }

  return (
    <div className="search-popup__container">
      <Loader loading={loading}>{locationsList}</Loader>
      {emptySearch}
    </div>
  );
};

SelectLocation.propTypes = {
  isFocused: PropTypes.bool.isRequired,
  cancelHandler: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,
  closePopupHandler: PropTypes.func.isRequired,
  setInitCoordinates: PropTypes.func.isRequired
};

export default SelectLocation;
